module.exports = __webpack_public_path__ + "img/latestImage.98a8c8b2.png";